export default () => ({
  services: [],
  currentService: {},
  wards: [],
})
